export default __webpack_public_path__ + "resources/icons/d211-94f3.png";